export default __webpack_public_path__ + "static/media/Cheese Labels (Flat all)-01.3659f7ad.png";